exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-0f763c08] {\n  padding-left: 0% !important;\n}\n.fa[data-v-0f763c08] {\n  color: red;\n  font-size: xx-large;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f763c08","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/attachments/CMAttachmentsPage/CMAttachmentsList.vue
// module id = 1100
// module chunks = 2